import { render, staticRenderFns } from "./CreatorDetail.vue?vue&type=template&id=2170fde6&scoped=true"
import script from "./CreatorDetail.vue?vue&type=script&lang=js"
export * from "./CreatorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2170fde6",
  null
  
)

export default component.exports